import AppController from './controller/app-controller.js';
import CookieConsentConfig from './utils/cookieconsent-config.js';
import { loadGtmWhenAllowed, pushGoogleConsentUpdate } from './utils/consent-gtm.js';

async function initCookieConsent() {
	const lang = document.documentElement.getAttribute('lang') || 'fr';
	CookieConsentConfig.language.default = lang.split('-')[0] || 'fr';

	const CookieConsent = await import('vanilla-cookieconsent');
	window.CookieConsent = CookieConsent;

	const syncGoogleConsent = () => {
		pushGoogleConsentUpdate(CookieConsent.acceptedCategory('analytics'));
	};

	CookieConsentConfig.onFirstConsent = syncGoogleConsent;
	CookieConsentConfig.onConsent = syncGoogleConsent;
	CookieConsentConfig.onChange = syncGoogleConsent;

	await CookieConsent.run(CookieConsentConfig);
	syncGoogleConsent();
	loadGtmWhenAllowed();

	document.addEventListener('click', (event) => {
		const trigger = event.target.closest('[data-manage-cookies]');
		if (!trigger) return;
		event.preventDefault();
		CookieConsent.showPreferences();
	});
}

document.addEventListener('DOMContentLoaded', async () => {
	const app = new AppController();
	window.app = app;
	await app.ready;
	await initCookieConsent();
});
